export default __webpack_public_path__ + "static/media/iexch_casino_bgone.5f62a1ea.jpg";